export default __webpack_public_path__ + "images/sorriso-de-toledo-logo.png";